export default "__VITE_ASSET__CRP7Ru0Q__"